export class StylingOptions {
    static options: { id: string; label: string }[] = [
        // { id: '', label: 'default' },
        { id: 'font-bold', label: 'Font Bold' },
        { id: 'text-red-200', label: 'Text Red' },
        { id: 'text-yellow-200', label: 'Text Yellow' },
        { id: 'bg-blue-200', label: 'Background Blue' },
        { id: 'bg-yellow-200', label: 'Background Yellow' },
        { id: 'bg-green-200', label: 'Background Green' },
        { id: 'bg-red-200', label: 'Background Red' },
        { id: 'text-green-200', label: 'Text Green' },
        { id: 'text-left', label: 'Text Align Left' },
        { id: 'text-right', label: 'Text Align Right' },
        { id: 'text-center', label: 'Text Align Center' },
        { id: 'text-justify', label: 'Text Align Justify' },
        { id: 'text-xs', label: 'Text Very Small' },
        { id: 'text-sm', label: 'Text Small' },
        { id: 'text-md', label: 'Text Medium' },
        { id: 'text-lg', label: 'Text Large' },
        { id: 'font-italic', label: 'Font Italic' },
        { id: 'underline', label: 'Text Underline ' },
        { id: 'line-through', label: 'Text Line Through' },
        { id: 'uppercase', label: 'Text Uppercase' },
        { id: 'lowercase', label: 'Text Lowercase' },
        { id: 'capitalize', label: 'Text Capitalize' },
        { id: 'text-500', label: 'Label' },
    ];
}
